import { BackgroundActivity } from "Components/Footer/BackgroundActivity";
import { Notification } from "Components/Footer/Notification";
import { ProjectCount } from "Components/Footer/ProjectCount";
import { PoweredBy } from "./PoweredBy";
import { useFooterStyles } from "./UseFooterStyles";

export function Footer() {
  const styles = useFooterStyles();
  return (
    <footer className={styles.root}>
      <BackgroundActivity />
      <ProjectCount />
      <PoweredBy />
      <Notification />
    </footer>
  );
}
